<template>
  <div class="index">
    <div class="content-left">
      <div class="titlelogo">
        <img src="@/assets/logo_khy.png" alt="" />

        <h3>医疗机构在线考核云平台</h3>
      </div>
      <div class="content_img1"></div>
      <div class="content_img2"></div>
    </div>
    <div class="content-right">
      <RegistCom></RegistCom>
      <div class="reg_title2"></div>
    </div>
  </div>
</template>
<script>
import RegistCom from './components/regist_up.vue';
export default {
  data () {
    return {};
  },
  methods: {},
  components: {
    RegistCom
  }
};
</script>
<style lang="scss" scoped>
.index {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  .content-left {
    flex-grow: 1;
    height: 100%;
    background-color: rgb(255, 255, 255);
    .titlelogo {
      margin-top: 20px;
      height: 100px;
      margin-left: 40px;
      display: flex;
      color: rgb(67, 66, 170);
      align-items: center;
      img {
        width: 100px;
        height: 100px;
      }
      h3 {
        width: 286px;
        height: 37px;
        font-size: 26px;
        font-family: PingFang SC;
        font-weight: bold;
        line-height: 37px;
        color: #333333;
        margin-left: 30px;
      }
    }
  }
}
.content-right {
  width: 800px;
  height: 100%;
  position: relative;
  .reg_title2 {
    width: 755px;
    height: 497px;
    margin-top: 410px;
    background-image: url(../../assets/reg_title2.png);
  }
}
.content_img1 {
  width: 625px;
  height: 143px;
  margin-left: 137px;
  margin-top: 80px;
  background-image: url(../../assets/reg_title.png);
  background-size: 100%;
}
.content_img2 {
  width: 641px;
  height: 471px;
  background-image: url(../../assets/reg_title1.png);
  margin-left: 137px;
  margin-top: 70px;
}
</style>
